import { toCamelCase } from "../../gtm/uploadDataComponent/helper";
import { theplant } from "../../proto";
import { getTables } from "../SizeGuide/helper";

type ISizeGuide = theplant.ec.service.sizeguide.ISizeGuide;
type ISizeGuideTable = theplant.ec.service.sizeguide.ISizeGuideTable;
type ISizeGuideTableRow = theplant.ec.service.sizeguide.ISizeGuideTableRow;

function safeJsonParse<T>(
  s: string | undefined,
  reviver?: (key: string, value: any) => any
): T | undefined {
  if (!s) return undefined;

  try {
    return JSON.parse(s, reviver) as T;
  } catch (error) {
    console.error("Failed to parse JSON:", error);
    return undefined;
  }
}

// see: product/SizeGuide/index.tsx
export function getSizeGuideTablesHTML() {
  const sizeTableEl = document.getElementById("size-guide-data");
  if (!sizeTableEl) return "";

  const jsonStr = sizeTableEl.innerHTML.trim();
  const sizeTableData = safeJsonParse<ISizeGuide>(jsonStr, toCamelCase);
  if (!sizeTableData) return "";

  const tables: ISizeGuideTable[] = [];
  for (const t of sizeTableData.tables || []) {
    const title = t.name || t.group;
    if (title?.includes("実寸サイズ")) {
      tables.push(t);
    }
  }

  const htmls: string[] = [];
  for (const t of tables) {
    if (t.rows) {
      const tableHTML = getSizeGuideTableHTML(t.rows);
      if (tableHTML) {
        htmls.push(tableHTML);
      }
    }
  }
  return htmls.join("\n");
}

function getSizeGuideTableHTML(rows: ISizeGuideTableRow[]) {
  const { titles, contents } = getTables({
    rows,
    specificSizeColumns: ["ラベルサイズ"],
  });

  return `<div class="table-wrapper">
  <div class="table-container">
    <table>
      <thead>
        <tr>
          ${titles.map((i) => `<th>${i}</th>`).join("")}
        </tr>
      </thead>
      <tbody>
        ${contents
          .map(
            (sizes) =>
              `<tr>${sizes
                .map(
                  (i) => `<td${i.bold ? ` class="boldTD"` : ""}>${i.size}</td>`
                )
                .join("")}</tr>`
          )
          .join("\n")}
      </tbody>
    </table>
  </div>
</div>`;
}
